import { render, staticRenderFns } from "./SalesBlock.vue?vue&type=template&id=504ac18e&scoped=true"
import script from "./SalesBlock.vue?vue&type=script&lang=js"
export * from "./SalesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504ac18e",
  null
  
)

export default component.exports